import * as React from 'react'
import { useSelector } from 'react-redux'
import * as _ from 'lodash'
import { IAppState } from '../../redux/reducers'


interface DashboardProps {

}

const Dashboard : React.FunctionComponent<DashboardProps> = ({}) : JSX.Element => {
    let auth = useSelector((state:IAppState) => state.auth)
    const userRole = auth && auth.userData &&  _.isArray(auth.userData.roles) && auth.userData.roles[0]
    
    return <p>Dashboard {userRole}</p>
}

export default Dashboard